import { Iso3166Alpha2Enum } from '@repo/utils'
import { PhoneNumberUtil } from 'google-libphonenumber'
import { defaultCountries, parseCountry } from 'react-international-phone'

// https://react-international-phone.vercel.app/docs/Usage/ModifyCountries
export const PHONE_FIELD_SUPPORTED_COUNTRIES = defaultCountries.filter(
  (country) => {
    const { iso2 } = parseCountry(country)

    return Object.values(Iso3166Alpha2Enum)
      .map((suppotedCountry) => suppotedCountry.toLowerCase())
      .includes(iso2)
  },
)

// https://react-international-phone.vercel.app/docs/Usage/PhoneValidation/
export const isPhoneValid = (phone: string) => {
  const phoneUtil = PhoneNumberUtil.getInstance()

  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))
  } catch (error) {
    return false
  }
}
